<template>
  <!-- style="height: 660px" -->
  <el-dialog
    :lock-scroll="false"
    v-model="formVisible"
    :title="
      isAdmin ? i18n.$t('OnlineStatus').account_management : i18n.$t('OnlineStatus').online_list
    "
    :before-close="dialogClose"
    :z-index="1000"
    :close-on-click-modal="false"
    :width="dialogWidth"
  >
    <loading :isLoading="userListGetting || locksGetting"></loading>
    <el-tabs v-model="activeTab">
      <!-- 在線列表 -->
      <el-tab-pane :label="i18n.$t('OnlineStatus').online_list" name="online">
        <div class="d-flex justify-content-between">
          <el-row class="mb-3">
            <el-tag class="py-2">
              {{ i18n.$t('OnlineStatus')['max_online_usernum'] }} :
              {{ !max_flag ? maximum : i18n.$t('As_5')['unlimited'] }}
            </el-tag>
            <el-tag type="success" class="py-2 ms-3">
              {{ i18n.$t('OnlineStatus')['current_usernum'] }} : {{ online }}
            </el-tag>
          </el-row>
          <el-button type="primary" @click="getOnlineUserList" id="refreshBtn">
            <el-icon>
              <Refresh />
            </el-icon>
          </el-button>
        </div>

        <el-table
          :data="userList"
          border
          :header-cell-style="{ background: '#f5f7fa' }"
          style="width: 100%"
          max-height="560"
        >
          <el-table-column
            prop="emp_code"
            :label="this.i18n.$t('TableHeader')['empid']"
            show-overflow-tooltip
          >
            <template #default="scope">
              <span>
                {{ scope.row.emp_code }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            :label="this.i18n.$t('TableHeader')['name']"
            show-overflow-tooltip
          >
            <template #default="scope">
              <span>
                {{ scope.row.name }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createdon"
            :label="this.i18n.$t('TableHeader')['logintime']"
            show-overflow-tooltip
          >
            <template #default="scope">
              <span>
                {{ scope.row.createdon }}
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" width="100" :label="this.i18n.$t('TableHeader').table_op">
            <template #default="scope">
              <div class="e-d-wrap">
                <el-button-group>
                  <el-button
                    type="danger"
                    size="small"
                    @click="handleDel(scope.row)"
                    :disabled="!isAdmin || scope.row.deletable === 0"
                  >
                    <el-icon>
                      <Delete />
                    </el-icon>
                  </el-button>
                </el-button-group>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <!-- 鎖定列表 -->
      <el-tab-pane v-if="isAdmin" :label="i18n.$t('OnlineStatus').locked_accounts" name="locked">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <span class="text-muted">{{ i18n.$t('OnlineStatus').unlock_hint }}</span>
          <el-button type="primary" :loading="locksGetting" @click="getLoginLocks">
            <el-icon><Refresh /></el-icon>
          </el-button>
        </div>

        <el-table
          :data="lockedUsers"
          border
          :header-cell-style="{ background: '#f5f7fa' }"
          max-height="560"
        >
          <el-table-column
            prop="emp_code"
            :label="i18n.$t('TableHeader').empid"
            show-overflow-tooltip
          />
          <el-table-column
            prop="account"
            :label="i18n.$t('OnlineStatus').account"
            show-overflow-tooltip
          />
          <el-table-column prop="name" :label="i18n.$t('TableHeader').name" show-overflow-tooltip />
          <el-table-column
            prop="fail_count"
            :label="i18n.$t('OnlineStatus').fail_count"
            width="100"
          />
          <el-table-column
            prop="lock_level"
            :label="i18n.$t('OnlineStatus').lock_level"
            width="100"
          />
          <el-table-column :label="i18n.$t('OnlineStatus').locked_until" min-width="160">
            <template #default="scope">
              {{ new Date(scope.row.locked_until).toLocaleString() }}
            </template>
          </el-table-column>
          <el-table-column :label="i18n.$t('TableHeader').table_op" align="center" width="110">
            <template #default="scope">
              <el-button
                type="warning"
                size="small"
                :loading="unlocking === scope.row.user_uid"
                :disabled="Boolean(unlocking) || locksGetting"
                @click="handleUnlock(scope.row)"
              >
                <el-icon class="me-1"><Unlock /></el-icon>
                {{ i18n.$t('OnlineStatus').unlock }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogClose">{{ i18n.$t('Button').close }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { useI18n } from '@/js/i18n';
import {
  SystemKickUserGetList,
  SystemKickUserDelete,
  SystemLoginLockGetList,
  SystemLoginLockDelete,
} from '@/js/api/system';
import { showMsg } from '@/js/basic';
import loading from '@/components/loading.vue';
import router, { resetRouter } from '@/router';

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['visibleEmit'],
  setup() {
    const i18n = useI18n();
    return { i18n };
  },
  components: {
    loading,
  },

  data() {
    return {
      formVisible: this.dialogVisible,
      isAdmin: sessionStorage.getItem('is_admin') === 'true',
      activeTab: 'online',
      lockedUsers: [],
      locksGetting: false,
      unlocking: '',
      // apiData: {
      //   columsWidth: {},
      //   tcw: [120, 120],
      //   tableColumns: ['user', 'ip'],
      //   tableData: [
      //     { user: 'test', ip: '192.168.1.1' },
      //     { user: 'qwr', ip: '192.168.1.2' },
      //   ],
      //   tableApiData: [],
      // },
      userList: [],
      maximum: '',
      max_flag: false,
      online: '',
      userListGetting: false,
      dialogWidth: '45%',
    };
  },
  mounted() {
    this.getOnlineUserList();
  },

  methods: {
    /** 取得在線列表，也可以是欲踢出的名單 */
    getOnlineUserList() {
      this.userListGetting = true;
      if (this.isAdmin) this.getLoginLocks();
      SystemKickUserGetList()
        .then((res) => {
          if (res.data.success) {
            this.userList = res.data.result.data.map((user) => {
              const { createdon, ...rest } = user;
              const date = new Date(createdon);
              date.setMilliseconds(0);
              const hours = date.getHours().toString().padStart(2, '0');
              const minutes = date.getMinutes().toString().padStart(2, '0');
              const seconds = date.getSeconds().toString().padStart(2, '0');
              const updatedCreatedOn =
                createdon !== 'None' && createdon !== 'NaT' && createdon !== 'NaN'
                  ? `${date.toISOString().slice(0, 10)} ${hours}:${minutes}:${seconds}`
                  : '';
              return {
                ...rest,
                createdon: updatedCreatedOn,
              };
            });
            this.maximum = res.data.result.maximum;
            this.max_flag = res.data.result.max_flag;
            this.online = res.data.result.online;
          } else if (
            !res.data.success &&
            res.data.msg === 'tuple indices must be integers or slices, not str'
          ) {
            showMsg('Your account has been kicked out or logged in repeatedly', 'error', 5000);
            localStorage.clear();

            // 從sessionStorage移除之前存的所有資料
            sessionStorage.clear();
            resetRouter();
            router.push('/login');
          } else {
            // showMsg(`${this.i18n.$t('Msg').online_list_fail}${res.data.msg}`, 'error', 3000);
            this.$store.dispatch('handleMsgError', {
              preMsg: `${this.i18n.$t('Msg').online_list_fail}: `,
              errorMsg: res.data.msg,
            });
          }
          this.userListGetting = false;
        })
        .catch((error) => {
          // console.log(error);
          showMsg(
            `${this.i18n.$t('Msg').online_list_fail}${JSON.stringify(error.data)}`,
            'error',
            3000,
          );
          this.userListGetting = false;
        });
    },

    /** 取得最新鎖定列表 */
    async getLoginLocks() {
      this.locksGetting = true;
      try {
        const res = await SystemLoginLockGetList();
        if (res.data.success) {
          this.lockedUsers = res.data.result;
        } else {
          this.lockedUsers = [];
          this.$store.dispatch('handleMsgError', { errorMsg: res.data.msg });
        }
      } catch (error) {
        this.lockedUsers = [];
        this.$store.dispatch('handleMsgError', {
          errorMsg: error.response?.data?.msg || error.message,
        });
      } finally {
        this.locksGetting = false;
      }
    },

    /**
     * 解鎖
     * @param user
     */
    handleUnlock(user) {
      this.$confirm(
        `${this.i18n.$t('OnlineStatus').unlock_confirm}【${user.name}】?`,
        this.i18n.$t('OnlineStatus').unlock,
        {
          confirmButtonText: this.i18n.$t('OnlineStatus').unlock,
          cancelButtonText: this.i18n.$t('Button').cancel,
          type: 'warning',
        },
      )
        .then(() => this.unlockAccount(user))
        .catch(() => {
          // User cancelled the confirmation.
        });
    },

    /**
     * 解除鎖定帳號
     * @param user
     */
    async unlockAccount(user) {
      this.unlocking = user.user_uid;
      try {
        const res = await SystemLoginLockDelete(user.user_uid);
        if (res.data.success) {
          showMsg(this.i18n.$t('OnlineStatus').unlock_success, 'success', 3000);
          await this.getLoginLocks();
        } else {
          this.$store.dispatch('handleMsgError', { errorMsg: res.data.msg });
        }
      } catch (error) {
        this.$store.dispatch('handleMsgError', {
          errorMsg: error.response?.data?.msg || error.message,
        });
      } finally {
        this.unlocking = '';
      }
    },

    kickOnlineUser(data, name) {
      SystemKickUserDelete(data)
        .then((res) => {
          if (res.data.success) {
            showMsg(
              `${this.i18n.$t('Msg').user}【${name}】${this.i18n.$t('Msg').kick_success}`,
              'success',
              3000,
            );
            this.getOnlineUserList();
          } else {
            // showMsg(`${this.i18n.$t('Msg').user}【${name}】${this.i18n.$t('Msg').kick_fail}${res.data.msg}`, 'error', 3000);
            this.$store.dispatch('handleMsgError', {
              preMsg: `${this.i18n.$t('Msg').user}【${name}】${this.i18n.$t('Msg').kick_fail}: `,
              errorMsg: res.data.msg,
            });
          }
        })
        .catch((error) => {
          showMsg(
            `${this.i18n.$t('Msg').user}【${name}】${this.i18n.$t('Msg').kick_fail}${JSON.stringify(
              error.data,
            )}`,
            'error',
            3000,
          );
        });
    },
    handleDel(data) {
      // console.log('deldata', data);
      const delData = data.uuid;
      const delName = data.name;
      // console.log('uuid', delData);
      // console.log('uuidType', typeof delData);
      this.$confirm(
        `${this.i18n.$t('OnlineStatus').surekick_user}【${data.name}】?`,
        `${this.i18n.$t('OnlineStatus').kick_user}【${data.name}】`,
        {
          confirmButtonText: `${this.i18n.$t('Button').kickconfirm}`,
          cancelButtonText: `${this.i18n.$t('Button').cancel}`,
          type: 'error',
        },
      )
        .then(() => {
          this.kickOnlineUser(delData, delName);
        })
        .catch((action) => {
          this.$message({
            type: 'info',
            message:
              action === 'cancel'
                ? `${this.i18n.$t('Button').kickcancel}`
                : `${this.i18n.$t('Button').kickcancel}`,
            // 前面是點選 取消 按鈕顯示的訊息；後面是點選 訊息右上角叉叉顯示的訊息
          });
        });
    },
    dialogVisibleSwitch(val) {
      this.$emit('visibleEmit', val);
    },
    dialogClose() {
      this.dialogVisibleSwitch(false);
    },
    setDialogWidth() {
      const windowSize = document.body.clientWidth;
      // console.log(windowSize);
      const defaultWidth = 1180; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dialogWidth = '100%';
      } else {
        this.dialogWidth = '45%';
      }
      // console.log(this.dialogWidth);
    },
  },
  watch: {
    // 監聽 props 更新，如果有更新也更新 data 內的資料
    dialogVisible: {
      handler(val, old) {
        if (val !== old) {
          this.setDialogWidth();
          this.formVisible = val;
          if (val) {
            this.activeTab = 'online';
            this.getOnlineUserList();
          }
        }
        // 開啟視窗強制重取
      },
    },
  },
};
</script>

<style>
.headerInfo {
  text-align: start;
  padding: 0 0 0 12px;
}
</style>
